import {IScaleRelativeToCenter, IColorChangeable, ICloneable} from '../../Interfaces';
import {Radius} from './Radius';
import {Label} from './Label';
import {Scaler} from '../Scaler';
import {Mesh} from './Mesh';
import {Selectable} from '../Selectable';

declare let THREE: any;

export class Circle extends Selectable implements IScaleRelativeToCenter, IColorChangeable, ICloneable {

  readonly scaler: Scaler;
  private _boundingBox;
  private color;
  private width: number;
  private height: number;
  // static readonly Name = "Circle";

  constructor() {
    super();
    this.add(new Mesh());
    const line = new Radius();
    // this.add(line);
    const label = new Label({width: 80, height: 40}, {fontSize: 24});
    // this.add(label);
    this.scaler = new Scaler();
    this.add(this.scaler);
    this._boundingBox = new THREE.Box3();
    this.color = new THREE.Color(0x000000);
    // this.name = Circle.Name;
  }

  update(width: number, height: number) {
    this.width = width;
    this.height = height;
    const innerCircle = this.getObjectByName(Mesh.Name);
    // const radiusLine = this.getObjectByName('radius');
    // const label = this.getObjectByName('Label');
    innerCircle.scale.set(width, 1, height);
    // radiusLine.update(width);
    // label.update(width);
    this.selection.update();
    this.scaler.update();
  }

  getSize() {
    this._boundingBox.setFromObject(this.getObjectByName(Mesh.Name));
    const size = new THREE.Vector3();
    this._boundingBox.getSize(size);
    return size;
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Mesh.Name)];
  }

  setColor(color): void {
    this.color.copy(color);
    this.getObjectByName(Mesh.Name).setColor(color);
    // this.getObjectByName(Radius.Name).setColor(color);
  }

  highlight() {
    super.highlight();
    this.scaler.update();
    this.scaler.visible = true;
  }

  unhighlight() {
    super.unhighlight();
    this.scaler.visible = false;
  }

  duplicate(): Circle {
    const circle = new Circle();
    circle.update(this.width, this.height);
    circle.setColor(this.color);
    return circle;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Circle",
      position: pos,
      height: this.height,
      width: this.width,
      color: this.color.getHex()
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Circle/index.ts